"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeMapper = void 0;
var offers_1 = require("../schemas/offers");
var product_category_relations_1 = require("../static/product-category-relations");
var service_line_category_relations_1 = require("../static/service-line-category-relations");
var story_category_relations_1 = require("../static/story-category-relations");
var type_crawler_1 = require("./type-crawler");
/**
 * Sets type relations based on the product category relations hierarchy map
 *
 * For Offer Data sets we set the "types" field on the relation from the parent up
 *
 * For Recommending or Searching Offers with an input "type" we search the Offer field "types" by the "type" relation
 * from the children down.
 *
 */
var TypeMapper = /** @class */ (function () {
    function TypeMapper() {
    }
    TypeMapper.type = function (subtype) {
        var productTypes = this.types('product');
        var serviceTypes = this.types('service');
        if (productTypes.indexOf(subtype) > -1) {
            return offers_1.OfferType.PRODUCT;
        }
        else if (serviceTypes.indexOf(subtype) > -1) {
            return offers_1.OfferType.SERVICE_LINE;
        }
        else {
            return null;
        }
    };
    TypeMapper.types = function (mode) {
        if (mode === void 0) { mode = 'all'; }
        switch (mode) {
            case 'all':
                return __spreadArrays(TypeMapper.flattenTypes(product_category_relations_1.PRODUCT_CATEGORY_RELATIONS), TypeMapper.flattenTypes(service_line_category_relations_1.SERVICE_LINE_CATEGORY_RELATIONS));
            case 'product':
                return TypeMapper.flattenTypes(product_category_relations_1.PRODUCT_CATEGORY_RELATIONS);
            case 'service':
                return TypeMapper.flattenTypes(service_line_category_relations_1.SERVICE_LINE_CATEGORY_RELATIONS);
            case 'story':
                return TypeMapper.flattenTypes(story_category_relations_1.STORY_CATEGORY_RELATIONS);
            default:
                throw Error("Not a valid mode \"" + mode + "\"");
        }
    };
    TypeMapper.allRelations = function (type, mode) {
        if (mode === void 0) { mode = 'product'; }
        if (!type) {
            throw new Error('Type input not provided');
        }
        switch (mode) {
            case 'product':
                return type_crawler_1.TypeCrawler.crawl(product_category_relations_1.PRODUCT_CATEGORY_RELATIONS, type.toString(), 'all', true);
            case 'service':
                return type_crawler_1.TypeCrawler.crawl(service_line_category_relations_1.SERVICE_LINE_CATEGORY_RELATIONS, type.toString(), 'all', true);
            case 'story':
                return type_crawler_1.TypeCrawler.crawl(story_category_relations_1.STORY_CATEGORY_RELATIONS, type.toString(), 'all', true);
            default:
                throw Error("Not a valid mode \"" + mode + "\"");
        }
    };
    TypeMapper.parentRelations = function (type, mode, includeFirst) {
        if (mode === void 0) { mode = 'product'; }
        if (includeFirst === void 0) { includeFirst = true; }
        if (!type) {
            throw new Error('Type input not provided');
        }
        switch (mode) {
            case 'product':
                return type_crawler_1.TypeCrawler.crawl(product_category_relations_1.PRODUCT_CATEGORY_RELATIONS, type.toString(), 'parents', includeFirst);
            case 'service':
                return type_crawler_1.TypeCrawler.crawl(service_line_category_relations_1.SERVICE_LINE_CATEGORY_RELATIONS, type.toString(), 'parents', includeFirst);
            case 'story':
                return type_crawler_1.TypeCrawler.crawl(story_category_relations_1.STORY_CATEGORY_RELATIONS, type.toString(), 'parents', includeFirst);
            default:
                throw Error("Not a valid mode \"" + mode + "\"");
        }
    };
    TypeMapper.childRelations = function (type, mode, includeFirst) {
        if (mode === void 0) { mode = 'product'; }
        if (includeFirst === void 0) { includeFirst = true; }
        if (!type) {
            throw new Error('Type input not provided');
        }
        switch (mode) {
            case 'product':
                return type_crawler_1.TypeCrawler.crawl(product_category_relations_1.PRODUCT_CATEGORY_RELATIONS, type.toString(), 'children', includeFirst);
            case 'service':
                return type_crawler_1.TypeCrawler.crawl(service_line_category_relations_1.SERVICE_LINE_CATEGORY_RELATIONS, type.toString(), 'children', includeFirst);
            case 'story':
                return type_crawler_1.TypeCrawler.crawl(story_category_relations_1.STORY_CATEGORY_RELATIONS, type.toString(), 'children', includeFirst);
            default:
                throw Error("Not a valid mode \"" + mode + "\"");
        }
    };
    /**
     * Builds the type relation model for a particular type
     */
    TypeMapper.relation = function (type, mode) {
        if (mode === void 0) { mode = 'product'; }
        if (!type || this.types('all').indexOf(type) === -1) {
            throw new Error("Type input \"" + type + "\" not provided or invalid");
        }
        switch (mode) {
            case 'product':
                return {
                    parents: type_crawler_1.TypeCrawler.crawl(product_category_relations_1.PRODUCT_CATEGORY_RELATIONS, type.toString(), 'parents', false),
                    children: type_crawler_1.TypeCrawler.crawl(product_category_relations_1.PRODUCT_CATEGORY_RELATIONS, type.toString(), 'children', false),
                    all: type_crawler_1.TypeCrawler.crawl(product_category_relations_1.PRODUCT_CATEGORY_RELATIONS, type.toString(), 'parents'),
                    immediate: this.findTypes(product_category_relations_1.PRODUCT_CATEGORY_RELATIONS, type)
                };
            case 'service':
                return {
                    parents: type_crawler_1.TypeCrawler.crawl(service_line_category_relations_1.SERVICE_LINE_CATEGORY_RELATIONS, type.toString(), 'parents', false),
                    children: type_crawler_1.TypeCrawler.crawl(service_line_category_relations_1.SERVICE_LINE_CATEGORY_RELATIONS, type.toString(), 'children', false),
                    all: type_crawler_1.TypeCrawler.crawl(service_line_category_relations_1.SERVICE_LINE_CATEGORY_RELATIONS, type.toString(), 'parents'),
                    immediate: this.findTypes(service_line_category_relations_1.SERVICE_LINE_CATEGORY_RELATIONS, type)
                };
            default:
                throw Error("Not a valid mode \"" + mode + "\"");
        }
    };
    TypeMapper.findTypes = function (data, id, parent) {
        if (data.hasOwnProperty(id)) {
            var inner = data[id];
            return { parent: parent, children: Object.keys(inner) };
        }
        for (var key in data) {
            if (data.hasOwnProperty(key)) {
                var inner = data[key];
                var result = this.findTypes(inner, id, key);
                if (result) {
                    return result;
                }
            }
        }
        return null;
    };
    TypeMapper.flattenTypes = function (data) {
        var results = [];
        for (var key in data) {
            if (data.hasOwnProperty(key)) {
                results.push(key);
                var inner = data[key];
                if (Object.keys(inner).length > 0) {
                    results.push.apply(results, this.flattenTypes(inner));
                }
            }
        }
        return results;
    };
    return TypeMapper;
}());
exports.TypeMapper = TypeMapper;
